'use client'

import Link from 'next/link'
import { cx } from '@/app/lib/utils'
import styles from './IconButton.module.scss'
import type { IconButtonProps } from './IconButton.types'

/**
 * IconButton — DS Entradas
 * Control cuadrado de solo icono. Requiere `ariaLabel` (sin texto visible).
 * Tamaños: L=48px · M=40px · S=32px.
 * Renderiza `<button>` (acción) o, si recibe `href`, `<a>` vía next/link (navegación).
 */
export function IconButton(props: IconButtonProps) {
  const {
    icon,
    ariaLabel,
    variant = 'ghost',
    shape = 'block',
    size = 'm',
    className,
  } = props

  const rootClass = cx(
    styles.btn,
    styles[`btn--${variant}`],
    styles[`btn--${shape}`],
    styles[`btn--${size}`],
    className,
  )

  const glyph = (
    <span className={styles.icon} aria-hidden="true">
      {icon}
    </span>
  )

  // Variante navegación: enlace estilizado como botón.
  if (props.href !== undefined) {
    return (
      <Link href={props.href} className={rootClass} aria-label={ariaLabel}>
        {glyph}
      </Link>
    )
  }

  // Variante acción.
  const { type = 'button', disabled = false, onClick } = props
  return (
    <button
      type={type}
      className={rootClass}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {glyph}
    </button>
  )
}
